import React from "react";
import { useTranslation } from "react-i18next";
import { useWhitelabel } from "../../../../contexts/WhitelabelContext";
import useWindowSize from "../../../../hooks/useWindowSize";
import { Button, Form, Modal } from "react-bootstrap";
import useDeviceType from "../../../../hooks/useDeviceType";

const CreditNoteForm = ({
  values,
  errors,
  touched,
  setFieldValue,
  setFieldTouched,
  handleChange,
  handleBlur,
  setValues,
  setShowCreditNoteModal,
  initialValues,
  handleSubmit,
}) => {
  const { t } = useTranslation();
  const { backgroundColor, fontColor } = useWhitelabel();
  const [width] = useWindowSize();
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>{t("crm.creditNote.amount")}</Form.Label>
        <Form.Control
          type="text"
          name="amount"
          value={values.amount}
          isInvalid={Boolean(touched.amount && errors.amount)}
          onBlur={handleBlur}
          onChange={handleChange}
        />
        {!!touched.amount && (
          <Form.Control.Feedback type="invalid">
            {errors.amount}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>{t("crm.creditNote.vat")}(%)</Form.Label>
        <Form.Control
          type="text"
          name="vat"
          value={values.vat}
          isInvalid={Boolean(touched.vat && errors.vat)}
          onBlur={handleBlur}
          onChange={handleChange}
        />
        {!!touched.vat && (
          <Form.Control.Feedback type="invalid">
            {errors.vat}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>{t("crm.creditNote.reason")}</Form.Label>
        <Form.Control
          as="textarea"
          name="reason"
          value={values.reason}
          isInvalid={Boolean(touched.reason && errors.reason)}
          onBlur={handleBlur}
          onChange={handleChange}
        />
        {!!touched.reason && (
          <Form.Control.Feedback type="invalid">
            {errors.reason}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      {isDesktop && (
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setShowCreditNoteModal(false)}
            className="me-2"
            style={{
              "--dynamic-bg-color": backgroundColor ?? "#0E1A2B",
              "--dynamic-font-color": fontColor ?? "#fff",
              border: "none",
            }}
          >
            {t("crm.creditNote.cancel")}
          </Button>
          <Button
            type="submit"
            variant="primary"
            style={{
              "--dynamic-bg-color": backgroundColor,
              "--dynamic-font-color": fontColor,
              border: "none",
            }}
          >
            {t("crm.creditNote.submit")}
          </Button>
        </Modal.Footer>
      )}
      {!isDesktop && (
        <div className="d-flex flex-column justify-content-center mt-3">
          <Button
            type="submit"
            variant="primary"
            className="mb-3"
            style={{
              "--dynamic-bg-color": backgroundColor,
              "--dynamic-font-color": fontColor,
              border: "none",
              padding: "10px",
            }}
          >
            {t("crm.creditNote.submit")}
          </Button>
          <Button
            variant="primary"
            onClick={() => setShowCreditNoteModal(false)}
            style={{
              "--dynamic-bg-color": backgroundColor,
              "--dynamic-font-color": fontColor,
              border: "none",
              padding: "10px",
            }}
          >
            {t("crm.creditNote.cancel")}
          </Button>
        </div>
      )}
    </Form>
  );
};

export default CreditNoteForm;
